import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// import { connect } from 'react-redux';
import Step3CardInfo from '@emyw/subscribe-lib/Step3CardInfo';
import { ValidateStep } from './index';
import { withAppContext } from '../AppContext';
import { loadUser } from '../actions/userActions';

class CardInfo extends Component {
    state = {
        proceedTo: undefined,
    }

    componentWillMount() {
        const { context } = this.props;
        const { user } = context.state;
        ValidateStep(window.location, user).then((directTo) => {
            if (directTo !== 'cardinfo') this.setState({ proceedTo: directTo });
        });
        context.setAppState({ currentStep: 'billing' });
        // if (user) {
        //     ValidateStep(window.location, user).then((directTo) => {
        //         if (directTo !== 'cardinfo') this.setState({ proceedTo: directTo });
        //     });
        // } else {
        //     this.setState({ proceedTo: 'setupaccount' });
        // }
    }

    // setNextLocation = (pathname) => {
    //     localStorage.setItem('enjoy-signup-progress', pathname);
    //     this.setState({ proceedTo: pathname });
    // }

    handleComplete = ({ paymentMethod/* , zipCode */ }) => {
        // localStorage.setItem('paymentMethod', paymentMethod);
        if (paymentMethod) {
            // if (zipCode) {
            /* Reload user with new payment method */
            (loadUser('network-only'))(({ user }) => {
                const { context } = this.props;
                context.setAppState({ user });
                // this.setNextLocation('confirm');
                this.setState({ proceedTo: 'confirm' });
            });
            // } else {
            //     // we need to collect the zipcode for sales tax calulations
            //     console.log('need a zip code!');
            // }
        }
    };

    handleChangePlanClick = () => {
        this.setState({ proceedTo: 'plan' });
    };

    handleChangePaymentClick = () => {
        this.setState({ proceedTo: 'payment' });
    }

    render() {
        const { context } = this.props;
        const { proceedTo } = this.state;
        const { user, skipPlanSelect } = context.state;

        if (proceedTo) return <Redirect push to={`/signup/${proceedTo}`} />;
        return (
            <div>
                <Helmet>
                    <title>Enjoy Signup - Billing Info</title>
                    <meta name="description" content="Payment card info" />
                </Helmet>
                {user && (
                    <Step3CardInfo
                        user={user}
                        onChangePlanClick={this.handleChangePlanClick}
                        onChangePaymentClick={this.handleChangePaymentClick}
                        onComplete={this.handleComplete}
                        planSelectDisabled={skipPlanSelect}
                        darkMode
                    />
                )}
            </div>
        );
    }
}

// const mapStateToProps = state => ({ user: state.user });

// export default connect(mapStateToProps)(CardInfo);
export default withAppContext(CardInfo);
